import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { deleteCityMasterUrl, insertCityMasterUrl, getCityMasterListUrl, updateCityMasterUrl, GET_CITY_MASTER_LIST, DELETE_CITY_MASTER, INSERT_CITY_MASTER, UPDATE_CITY_MASTER, headers } from "../../../utils/constants";

export const getCityMasterList_action = (CountryID, StateID, CityName, Status) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            CountryID: CountryID,
            StateID: StateID,
            CityName: CityName,
            Status:  Status != '' && Status != ''? Status: null,
        }
        console.log("getVisaInvitation_action Action------->", params)
        const res = await axiosGet(getCityMasterListUrl, params, headers)

        dispatch({
            type: GET_CITY_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteCityMaster_action = (CityID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            CityID: CityID,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(deleteCityMasterUrl, params, headers)

        dispatch({
            type: DELETE_CITY_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertCityMaster_action = (countryID, stateID, cityName) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            countryID: countryID,
            stateID: stateID,
            cityName: cityName,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertCityMasterUrl, params, headers)

        dispatch({
            type: INSERT_CITY_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateCityMaster_action = (countryID, stateID, cityID, cityName) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            countryID: countryID,
            stateID: stateID,
            cityID: cityID,
            cityName: cityName,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(updateCityMasterUrl, params, headers)

        dispatch({
            type: UPDATE_CITY_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

// export const getHallMasterDetails_action = (HallId) => async (dispatch) => {
//     try {
//         const params = {
//             UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
//             ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
//             HallId: HallId
//         }
//         console.log("getVisaInvitation_action Action------->", params)

//         const res = await axiosGet(getHallMasterDetailsUrl, params, headers)

//         dispatch({
//             type: GET_HALL_MASTER_DETAILS,
//             payload: res,
//         });
//         return Promise.resolve(res)
//     } catch (error) {
//         return Promise.reject(error)
//     }
// }